import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import RfqLanding from "./pages/RfqLanding";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RfqLanding />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton theme="light" />
    </div>
  );
}

export default App;
